export function getQueryParameters<T>(): T {
    const queryParameters = window.location.search.length > 0 ? window.location.search.replace("?", "").split("&") : [];

    const result = {} as T;
    queryParameters.map((queryParameter) => {
        const queryParameterName = queryParameter.split("=")[0].toLowerCase();
        const queryParameterValue = queryParameter.split("=")[1];

        result[queryParameterName] = queryParameterValue;
    });

    return result;
}

export function setQueryParameters(params: Record<string, any>): string {
    let searchParams = "";
    const paramsKeys = Object.keys(params);
    if (paramsKeys.length === 0) {return "";}
    paramsKeys.forEach((param, index) => {
        searchParams = `${searchParams}${param}=${params[param]}${index === paramsKeys.length - 1 ? "" : "&"}`;
    });
    return `?${searchParams}`;
}
